<script>
import Component from '~/sites/soh/pages/contact/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/kontakt',
      de: '/impressum',
      en: '/contact',
      sk: '/kontakt',
    },
  },
}
</script>
